// extracted by mini-css-extract-plugin
module.exports = {"leads_list__count":"leads_list__count","leads_list__count__label":"leads_list__count__label","leads_list__count__number":"leads_list__count__number"};